<script setup lang="ts">
  import { ref } from 'vue'
  import { cn } from '@gat-ship/vue-components'
  import {
    defineCustomFieldsView,
    provideCustomFieldsView
  } from '../composables/useCustomFieldsView'
  import CustomFieldsTargetSelect from './CustomFieldsTargetSelect.vue'
  import CustomFieldsView from '../views/CustomFieldsView.vue'
  import SystemFieldsView from '../views/SystemFieldsView.vue'

  // Router-agnostic body for the AdministrationModal Field Customization panel.
  // Mounts as a descendant of AccessRolesCollectionProvider (wrapped by the
  // panel), so defineCustomFieldsView() can safely inject the access-roles
  // context here. Provides the view context to its target select and the two
  // field views, which are otherwise identical to the routed sidebar layout.
  const ctx = defineCustomFieldsView()
  provideCustomFieldsView(ctx)

  const activeTab = ref<'custom' | 'system'>('custom')

  function tabClass(value: string) {
    return cn(
      'cursor-pointer rounded-md px-3 py-1.5 text-sm font-medium transition-colors',
      activeTab.value === value
        ? 'bg-background text-foreground shadow-xs'
        : 'text-muted-foreground hover:text-foreground'
    )
  }
</script>

<template>
  <div class="flex items-center gap-2">
    <div class="bg-muted flex items-center gap-1 rounded-lg p-1">
      <button
        type="button"
        :class="tabClass('custom')"
        @click="activeTab = 'custom'"
      >
        Custom Fields
      </button>
      <button
        type="button"
        :class="tabClass('system')"
        @click="activeTab = 'system'"
      >
        System Fields
      </button>
    </div>
    <CustomFieldsTargetSelect class="ml-auto max-w-[250px]" />
  </div>
  <CustomFieldsView v-if="activeTab === 'custom'" />
  <SystemFieldsView v-else />
</template>
